/**
 * 壁纸配置文件
 * 定义系统可用的所有壁纸选项
 */

// 默认壁纸 ID
export const DEFAULT_WALLPAPER_ID = 'default_gradient';

// 壁纸类型
export const WALLPAPER_TYPES = {
  GRADIENT: 'gradient'  // 渐变色
};

// 所有可用壁纸配置
export const wallpapers = [
  // 默认壁纸 - 蓝紫粉渐变
  {
    id: 'default_gradient',
    name: '蓝紫粉渐变',
    type: WALLPAPER_TYPES.GRADIENT,
    value: 'linear-gradient(45deg, rgb(18, 194, 233), rgb(196, 113, 237), rgb(246, 79, 89))',
    style: {
      backdropFilter: 'blur(20px) saturate(120%)',
      WebkitBackdropFilter: 'blur(20px) saturate(120%)'
    },
    isDefault: true
  },
  // 其他渐变色选项 - 参考默认壁纸的明亮清新风格
  {
    id: 'vibrant_gradient',
    name: '炫彩渐变',
    type: WALLPAPER_TYPES.GRADIENT,
    value: 'linear-gradient(45deg, rgb(0, 255, 255), rgb(0, 123, 255), rgb(138, 43, 226), rgb(255, 0, 255), rgb(255, 165, 0))',
    style: {
      backdropFilter: 'blur(25px) saturate(110%)',
      WebkitBackdropFilter: 'blur(25px) saturate(110%)'
    }
  },
  {
    id: 'sky_sunset_gradient',
    name: '天空日落',
    type: WALLPAPER_TYPES.GRADIENT,
    value: 'linear-gradient(to top, rgb(255, 153, 51), rgb(0, 153, 255))',
    style: {
      backdropFilter: 'blur(30px) saturate(130%)',
      WebkitBackdropFilter: 'blur(30px) saturate(130%)'
    }
  },
  {
    id: 'dreamy_rainbow_gradient',
    name: '梦幻彩虹',
    type: WALLPAPER_TYPES.GRADIENT,
    value: 'linear-gradient(180deg, rgb(0, 200, 180), rgb(0, 150, 255), rgb(100, 100, 255), rgb(150, 200, 255), rgb(220, 255, 220), rgb(255, 230, 220))',
    style: {
      backdropFilter: 'blur(35px) saturate(125%)',
      WebkitBackdropFilter: 'blur(35px) saturate(125%)'
    }
  },
  {
    id: 'serene_sky_gradient',
    name: '宁静天空',
    type: WALLPAPER_TYPES.GRADIENT,
    value: 'linear-gradient(to bottom, rgb(0, 200, 255) 0%, rgb(0, 200, 255) 50%, rgb(150, 220, 240) 70%, rgb(255, 230, 200) 85%, rgb(255, 200, 180) 100%)',
    style: {
      backdropFilter: 'blur(25px) saturate(115%)',
      WebkitBackdropFilter: 'blur(25px) saturate(115%)'
    }
  },
  {
    id: 'galaxy_gradient',
    name: '星河银河',
    type: WALLPAPER_TYPES.GRADIENT,
    value: 'linear-gradient(45deg, rgb(63, 81, 181), rgb(100, 181, 246), rgb(159, 168, 218))',
    style: {
      backdropFilter: 'blur(30px) saturate(130%)',
      WebkitBackdropFilter: 'blur(30px) saturate(130%)'
    }
  },
  {
    id: 'midnight_gradient',
    name: '午夜星空',
    type: WALLPAPER_TYPES.GRADIENT,
    value: 'linear-gradient(45deg, rgb(21, 32, 43), rgb(52, 73, 94), rgb(84, 110, 122))',
    style: {
      backdropFilter: 'blur(25px) saturate(120%)',
      WebkitBackdropFilter: 'blur(25px) saturate(120%)'
    }
  }
];

/**
 * 获取默认壁纸
 * @returns {Object} 默认壁纸对象
 */
export const getDefaultWallpaper = () => {
  return wallpapers.find(wp => wp.id === DEFAULT_WALLPAPER_ID) || wallpapers[0];
};

/**
 * 根据ID获取壁纸
 * @param {string} id 壁纸ID
 * @returns {Object|null} 壁纸对象或null
 */
export const getWallpaperById = (id) => {
  return wallpapers.find(wp => wp.id === id) || null;
};

/**
 * 应用壁纸到页面
 * @param {Object} wallpaper 壁纸对象
 */
export const applyWallpaper = (wallpaper) => {
  if (!wallpaper) return;
  
  // 应用背景
  document.body.style.background = wallpaper.value;
  document.body.style.backgroundAttachment = 'fixed';
  document.body.style.backgroundSize = wallpaper.type === 'image' ? 'cover' : 'auto';
  
  // 应用高斯模糊等样式效果
  if (wallpaper.style) {
    Object.keys(wallpaper.style).forEach(key => {
      document.body.style[key] = wallpaper.style[key];
    });
  } else {
    // 如果没有style，清除body的高斯模糊效果
    document.body.style.backdropFilter = 'none';
    document.body.style.webkitBackdropFilter = 'none';
  }
  
  // 减少背景切换时的闪烁
  document.body.style.transition = 'background 0.15s ease';
};

/**
 * 根据壁纸值找到对应的壁纸对象
 * @param {string} wallpaperValue 壁纸值
 * @returns {Object|null} 壁纸对象或null
 */
export const findWallpaperByValue = (wallpaperValue) => {
  return wallpapers.find(wp => wp.value === wallpaperValue) || null;
};

export default wallpapers; 